import { render } from "./AnalyticsNotesForeignTradeTextYearly.vue?vue&type=template&id=1eec7ead&ts=true"
import script from "./AnalyticsNotesForeignTradeTextYearly.vue?vue&type=script&lang=ts"
export * from "./AnalyticsNotesForeignTradeTextYearly.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__